import { render } from "./EmployeeForm.vue?vue&type=template&id=2d277539&scoped=true"
import script from "./EmployeeForm.vue?vue&type=script&lang=js"
export * from "./EmployeeForm.vue?vue&type=script&lang=js"

import "./EmployeeForm.vue?vue&type=style&index=0&id=2d277539&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2d277539"

export default script